import { render, staticRenderFns } from "./createNewsletter.vue?vue&type=template&id=1bd35682&"
import script from "./createNewsletter.vue?vue&type=script&lang=js&"
export * from "./createNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./createNewsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports